import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
import Button from "react-bootstrap-button-loader";
import {
  converDateIntoLocalDate,
  classNames,
  COMMON_FAIL_MESSAGE,
} from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  openGenerateBadgeModal,
  getSingleBadgerecord,
  openBadgeDesignModal,
  deleteTemplate,
  markDefault,
} from "BadgeDesignAction";
import LocaleStrings from "Languages";

class BadgeDesignItem extends React.Component {
  constructor(props) {
    super(props);
    this.editBadgeTempalte = this.editBadgeTempalte.bind(this);
    this.deletBadgeTempalte = this.deletBadgeTempalte.bind(this);
  }

  /* 
    Edit Badge design template
  */
  editBadgeTempalte(badgeTemplate) {
    /* 
      Set this single badge data to store [here true is for set and 'false' for remove]
    */

    this.props.getSingleBadgerecord(badgeTemplate, true);
    this.props.openBadgeDesignModal(true); // Open modal for edit
  }

  /*
    Delete badge template with id
  */
  deletBadgeTempalte(badgeTemplate) {
    let { session } = this.props;
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    confirmAlert({
      title: LocaleStrings.dashboard_badgedesign_delete_template,
      message: LocaleStrings.dashboard_badgedesign_delete_template_message,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteTemplate(
              session,
              badgeTemplate.badgeid,
              (CallBackResponse) => {
                if (CallBackResponse.success) {
                  this.props.showSuccess(
                    LocaleStrings.dashboard_badgedesign_delete_template_success
                  );

                  /* Fetch template list */
                  this.props.additionCallback(pageNo);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  handleDefault = (item) => {
    let { session, pagination, currentPage } = this.props;
    // console.log("item :- ", item);

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>{LocaleStrings.dashboard_badgedesign_default_update_title}</h1>
            <p>{LocaleStrings.dashboard_badgedesign_default_update_subtitle}</p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.props.markDefault(
                    session,
                    {
                      badgeid: item.badgeid,
                      eventid: item.eventid,
                    },
                    (response) => {
                      onClose();
                      if (response.success === 1) {
                        this.props.showSuccess(
                          LocaleStrings.dashboard_badgedesign_default_update_success
                        );
                        pagination(currentPage);
                      } else {
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      }
                    }
                  );
                }}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  };

  /*
    Open generate badge
  */
  _handelGenerateBadgeModal(badgeid) {
    this.props.openGenerateBadgeModal(true); // open modal fc call
    this.props.setStateCurrentTemplateId(badgeid); // Update selected template id to parent page
  }

  render() {
    let { badgeTemplate } = this.props;

    var createdon = badgeTemplate.createdon
      ? converDateIntoLocalDate(badgeTemplate.createdon)
      : "";

    return (
      <tr key={badgeTemplate.badgeid}>
        {/* Badge Name */}
        <td className="badge-custom-td">
          <div className="">{badgeTemplate.badgename}</div>
          <div className="custom-text1-theme-normal">
            {badgeTemplate.isdefault ? `(${LocaleStrings.default})` : ""}
          </div>
        </td>
        {/* Created On */}
        <td className="badge-custom-td">
          <div className="vcenter">{createdon} </div>
          <div
            className="custom-text1-theme-normal text-decoration-underline pointer"
            onClick={() => this.handleDefault(badgeTemplate)}
          >
            {badgeTemplate.isdefault ? "" : `(${LocaleStrings.set_default})`}
          </div>
        </td>
        <td>
          <div className="table-ation-td">
            {/* Select Attendee & Generate */}

            <div>
              {/* Edit Badge Template */}

              <button
                onClick={(e) => this.editBadgeTempalte(badgeTemplate)}
                className="btn btn-custom-table-white"
              >
                {LocaleStrings.button_edit}
              </button>
            </div>
            <div>
              <Button
                className="btn btn-custom-table-blue"
                onClick={(e) => {
                  this._handelGenerateBadgeModal(badgeTemplate.badgeid);
                }}
                type="button"
              >
                {LocaleStrings.dashboard_badgedesign_select_Generate}
              </Button>
            </div>

            {/* Delete Badge Template */}
            <div
              className={classNames(badgeTemplate.isdefault ? "hidden" : "")}
            >
              <button
                className="i-custom-table-delete"
                type="button"
                onClick={(e) => this.deletBadgeTempalte(badgeTemplate)}
              >
                <img
                  className="button-delete-icon"
                  src="../../style/images/delete.png"
                />
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  var templateData = null;
  if (
    state.templateData &&
    state.templateData.resource &&
    state.templateData.resource.length > 0
  ) {
    templateData = state.templateData.resource[0];
  }

  return {
    session: state.session,
    templateData,
    settingData: state.SettingData.resource,
  };
};

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openGenerateBadgeModal,
  getSingleBadgerecord,
  openBadgeDesignModal,
  deleteTemplate,
  markDefault,
})(BadgeDesignItem);
